import { Modal as AntModal } from "antd";
import { PropsWithChildren, ReactNode } from "react";
import "./Modal.scss";

export interface ModalProps {
    isVisible: boolean;
    onCancel?: () => void;
    onSubmit?: () => void;
    className?: string;
    width?: string;
    destroyOnClose?: boolean;
    closeIcon?: ReactNode;
    /** Show the antd corner close ("×") button. Defaults to antd's default (true). */
    closable?: boolean;
    title?: string;
    centered?: boolean;
    replaceDefaultStyles?: boolean;
    keyboard?: boolean;
    /**
     * A request started from this modal is in flight. The corner close button,
     * a mask click and Esc do nothing and the close button shows as disabled
     * (ui-design-principle-modals-dialogs: lock the whole dialog while submitting).
     */
    busy?: boolean;
}

/** onCancel to hand to antd: a no-op while the modal is busy. */
export const guardBusyCancel = (busy: boolean | undefined, onCancel?: () => void) =>
    busy ? () => undefined : onCancel;

export const Modal = ({
    isVisible,
    onCancel,
    onSubmit,
    className = "",
    width,
    children,
    destroyOnClose,
    closeIcon,
    closable,
    title,
    replaceDefaultStyles,
    keyboard,
    busy,
}: PropsWithChildren<ModalProps>) => {
    const baseClassName = replaceDefaultStyles ? className : `modal ${className}`;
    return (
        <AntModal
            title={title}
            visible={isVisible}
            footer={null}
            onCancel={guardBusyCancel(busy, onCancel)}
            onOk={onSubmit}
            className={busy ? `${baseClassName} modal--busy` : baseClassName}
            width={width}
            centered={true}
            destroyOnClose={destroyOnClose}
            closeIcon={closeIcon}
            closable={closable}
            keyboard={busy ? false : keyboard !== undefined ? keyboard : true}
        >
            {children}
        </AntModal>
    );
};
